import React, { FC } from 'react';
import { NumberLoader } from '@components/NumberLoader/NumberLoader';
import { FormattedMessage } from 'react-intl';
import { formatWithSpaces } from '@specs/helpers';
import s from './toysCount.module.scss';
import { useGetTotalToysAmount } from '@services/toys/hooks/useGetTotalToysAmount';
import { useRouter } from 'next/router';
import { PageQueries } from '@specs/navigation';
import { useGetShopifyToysAmount } from '@services/toys/hooks/useGetShopifyToysAmount';
interface Props {
  isPhysicalPage: boolean;
}
export const ToysCount: FC<Props> = ({
  isPhysicalPage
}) => {
  const router = useRouter();
  const {
    priceSortCurrency
  }: PageQueries = router.query;
  const {
    data: digitalToysCount,
    isLoading: digitalToysCountLoading
  } = useGetTotalToysAmount({
    currency: priceSortCurrency
  }, {
    enabled: !isPhysicalPage
  });
  const {
    data: physicalToysData,
    isLoading: physicalToysCountLoading
  } = useGetShopifyToysAmount({
    published_status: 'published'
  }, {
    enabled: isPhysicalPage
  });
  const isLoading = isPhysicalPage ? physicalToysCountLoading : digitalToysCountLoading;
  const count = isPhysicalPage ? physicalToysData?.count : digitalToysCount;
  return <div className={s.toysCount} data-sentry-component="ToysCount" data-sentry-source-file="ToysCount.tsx">
            {isLoading ? <NumberLoader digitCount={3} /> : <FormattedMessage id='count.toys' values={{
      count: () => formatWithSpaces(count ?? 0)
    }} />}
        </div>;
};